export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const addDocumentButtonWrapperStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  mb: 2,
};
